import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BlankWhiteLayout from 'src/layouts/BlankWhiteLayout';
import Button from 'src/components/common/designSystem/Button';
import { AutoFloatingPanel } from 'src/components/common/AutoFloatingPanel';
import LoginPanel from 'src/components/Login/LoginPanel';
import BaoGeography from 'src/images/subjects/geography.svg?react';
import BackgroundPattern from 'src/components/common/BackgroundPattern';

const FamilyCodeCongratsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showLoginPanel, setShowLoginPanel] = useState(false);

  const handleContinue = () => {
    setShowLoginPanel(true);
  };

  const handleAfterSocialLogin = () => {
    // After successful login, navigate to parent onboarding
    const newParams = new URLSearchParams(searchParams);
    navigate(`/onboarding/parent/firstname?${newParams.toString()}`, {
      replace: true,
    });
  };

  const handleEmailClick = () => {
    setShowLoginPanel(false);
    navigate(`/login/email?${searchParams.toString()}`);
  };

  return (
    <BlankWhiteLayout>
      <div
        className={
          'flex flex-col justify-center flex-1 items-center relative px-4'
        }
      >
        <BackgroundPattern color={'#B991FB'} />
        <div className="z-10 flex flex-col items-center justify-center py-6 px-4 w-full gap-4 bg-white rounded-lg">
          <div
            className={'flex flex-col justify-center items-center gap-2 w-full'}
          >
            <BaoGeography className={'w-28 h-auto'} />

            <div className="font-bold text-4xl text-center">
              {t('family.code.congrats.title')}
            </div>

            <div className="text-center text-base">
              {t('family.code.congrats.description')}
            </div>
          </div>

          <Button
            type="primary"
            onClick={handleContinue}
            data-testid="continue-button"
          >
            {t('global.continue')}
          </Button>
        </div>
      </div>

      {/* Login Panel */}
      <AutoFloatingPanel
        isOpen={showLoginPanel}
        onClose={() => setShowLoginPanel(false)}
        data-testid="login-panel"
      >
        <LoginPanel
          title={t('login.createAccount')}
          className="p-2"
          onLogin={handleAfterSocialLogin}
          onEmailClick={handleEmailClick}
        />
      </AutoFloatingPanel>
    </BlankWhiteLayout>
  );
};

export default FamilyCodeCongratsPage;
